export const COLLECTING_ENTITIES_REPORT_TYPES = {
  SUMMARY: 'bank_collections_summary',
  INTERMEDIATE: 'intermediate_entities_collection',
  DETAIL: 'collecting_entities_detail',
};

export const COLLECTING_ENTITIES_REPORT_OPTIONS = [
  { value: COLLECTING_ENTITIES_REPORT_TYPES.SUMMARY, label: 'Resumen' },
  { value: COLLECTING_ENTITIES_REPORT_TYPES.INTERMEDIATE, label: 'Recaudación' },
  { value: COLLECTING_ENTITIES_REPORT_TYPES.DETAIL, label: 'Detalle' },
];

export const COLLECTING_ENTITIES_DETAIL_COLUMNS = [
  {
    key: 'payment_date',
    label: 'Fecha de pago',
    align: 'center',
    kind: 'text',
    minWidth: 120,
    pdfWidth: 22,
  },
  {
    key: 'legal_entity_name',
    label: 'Entidad intermedia',
    align: 'left',
    kind: 'text',
    minWidth: 220,
    pdfWidth: 38,
  },
  {
    key: 'contract_number',
    label: 'N° de orden',
    align: 'center',
    kind: 'text',
    minWidth: 110,
    pdfWidth: 18,
  },
  {
    key: 'subscriber_name',
    label: 'Suscriptor',
    align: 'left',
    kind: 'text',
    minWidth: 220,
    pdfWidth: 42,
  },
  {
    key: 'fee_label',
    label: 'Cuota',
    align: 'center',
    kind: 'text',
    minWidth: 110,
    pdfWidth: 20,
  },
  {
    key: 'month_year',
    label: 'Mes/Año',
    align: 'center',
    kind: 'text',
    minWidth: 100,
    pdfWidth: 16,
  },
  {
    key: 'payment_method_name',
    label: 'Forma de pago',
    align: 'left',
    kind: 'text',
    minWidth: 200,
    pdfWidth: 34,
  },
  {
    key: 'due_date',
    label: 'Vencimiento',
    align: 'center',
    kind: 'text',
    minWidth: 120,
    pdfWidth: 20,
  },
  {
    key: 'fee_amount',
    label: 'Cuota pura',
    align: 'right',
    kind: 'amount',
    minWidth: 120,
    pdfWidth: 20,
  },
  {
    key: 'social_fee_amount',
    label: 'Cuota social',
    align: 'right',
    kind: 'amount',
    minWidth: 120,
    pdfWidth: 20,
  },
  {
    key: 'pei_amount',
    label: 'P.E.I.',
    align: 'right',
    kind: 'amount',
    minWidth: 90,
    pdfWidth: 16,
  },
  {
    key: 'fire_insurance_amount',
    label: 'Seguro de incendio',
    align: 'right',
    kind: 'amount',
    minWidth: 150,
    pdfWidth: 24,
  },
  {
    key: 'life_insurance_amount',
    label: 'Seguro de vida',
    align: 'right',
    kind: 'amount',
    minWidth: 130,
    pdfWidth: 22,
  },
  {
    key: 'real_estate_tax_amount',
    label: 'Impuesto inmobiliario',
    align: 'right',
    kind: 'amount',
    minWidth: 160,
    pdfWidth: 24,
  },
  {
    key: 'interest_amount',
    label: 'Intereses',
    align: 'right',
    kind: 'amount',
    minWidth: 120,
    pdfWidth: 18,
  },
  {
    key: 'amount',
    label: 'Importe',
    align: 'right',
    kind: 'amount',
    minWidth: 120,
    pdfWidth: 20,
  },
  {
    key: 'real_score',
    label: 'Cantidad de cuotas',
    align: 'right',
    kind: 'quantity',
    minWidth: 140,
    pdfWidth: 22,
  },
];

export const INITIAL_FILTERS = {
  reportType: COLLECTING_ENTITIES_REPORT_TYPES.SUMMARY,
  dateStart: '',
  dateEnd: '',
  plan: 'all',
  legalEntity: 'all',
  group: 'all',
  orderNumber: '',
  whitHouse: 'not_selected',
};

export const MESSAGES = {
  ERROR: {
    FETCH_DATA: 'Error al obtener el reporte de entidades recaudadoras.',
    INVALID_RANGE: 'La fecha desde no puede ser mayor que la fecha hasta.',
    DATES_REQUIRED: 'Debe ingresar Fecha Desde y Fecha Hasta.',
    LEGAL_ENTITY_REQUIRED: 'Debe seleccionar una entidad intermedia.',
  },
  EMPTY_STATE: 'No se encontraron datos con los filtros seleccionados.',
};
